module.exports = __webpack_public_path__ + "static/krstol 210318.jfif";